export default __webpack_public_path__ + "static/media/coltec2.8c2640d0.jpg";